import React from 'react'
import { useTranslation } from 'react-i18next'
import { TooltipList } from 'packages/ui/Graph'
import { formatYAxisLoss } from '../../../../utils/graphs'
import { CustomTooltipProps } from '../../../../utils/types'
import { LOSS_COLOR } from '../../../../utils/constants'

const LossTooltip: React.FC<CustomTooltipProps> = ({ active, label, payload }) => {
  const { t } = useTranslation()
  if (!active || !payload || !payload.length) return null

  const loss = payload.find(({ dataKey }) => dataKey === 'loss')
  const lossValue = typeof loss?.value === 'number' ? loss.value : 0
  const dataPoint = payload[0]?.payload

  return (
    <TooltipList
      title={dataPoint?.formattedTime || label}
      list={[
        {
          color: LOSS_COLOR,
          label: t('wan.graphs.loss.loss'),
          value: formatYAxisLoss(lossValue)
        },
      ]}
    />
  )
}

export default LossTooltip
